import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

function Login(props) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [badLogin, setBadLogin] = useState(false);
  const [loginForm, setloginForm] = useState({ email: "", password: "" });

  const [magicMode, setMagicMode] = useState(false);
  const [magicEmail, setMagicEmail] = useState("");
  const [magicSent, setMagicSent] = useState(false);
  const [magicLoading, setMagicLoading] = useState(false);

  function logMeIn(event) {
    setBadLogin(false);
    fetch(`${process.env.REACT_APP_API_URL}/token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: loginForm.email, password: loginForm.password }),
    })
      .then((response) => {
        if (!response.ok) { setBadLogin(true); throw new Error(); }
        return response.json();
      })
      .then((data) => { props.setToken(data.access_token); })
      .then(() => { setLoading(true); navigate("/profile"); })
      .catch(() => setBadLogin(true))
      .finally(() => setloginForm({ email: "", password: "" }));
    event.preventDefault();
  }

  function handleChange(event) {
    const { value, name } = event.target;
    setloginForm((prev) => ({ ...prev, [name]: value }));
  }

  async function requestMagicLink(event) {
    event.preventDefault();
    setMagicLoading(true);
    await fetch(`${process.env.REACT_APP_API_URL}/request-magic-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: magicEmail }),
    });
    setMagicLoading(false);
    setMagicSent(true);
  }

  return (
    <Fragment>
      {loading ? (
        <div className="loader-container">
          <img src="./loader.gif" className="loader" alt="chargement" />
        </div>
      ) : (
        <div className="login-page">
          <h1 className="login-top-title">Espace animateur</h1>
          <div className="login-container">
            <h1 className="login-title">Connectez-vous</h1>

            {!magicMode ? (
              <>
                <form className="login-form">
                  <input
                    onChange={handleChange}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={loginForm.email}
                    className="form-input-container"
                  />
                  <input
                    onChange={handleChange}
                    type="password"
                    name="password"
                    placeholder="Mot de passe"
                    value={loginForm.password}
                    className="form-input-container"
                  />
                  {badLogin && (
                    <div className="bad-login-div">Mot de passe ou email incorrect</div>
                  )}
                  <button className="orange-button" onClick={logMeIn}>
                    Se connecter
                  </button>
                </form>
                <button
                  className="magic-link-toggle"
                  onClick={() => setMagicMode(true)}
                >
                  Se connecter sans mot de passe
                </button>
              </>
            ) : (
              <>
                {!magicSent ? (
                  <form className="login-form" onSubmit={requestMagicLink}>
                    <p className="magic-link-hint">
                      Entrez votre email pour recevoir un lien de connexion valable 15 minutes.
                    </p>
                    <input
                      type="email"
                      placeholder="Email"
                      value={magicEmail}
                      onChange={(e) => setMagicEmail(e.target.value)}
                      className="form-input-container"
                      required
                    />
                    <button className="orange-button" type="submit" disabled={magicLoading}>
                      {magicLoading ? "Envoi..." : "Recevoir un lien"}
                    </button>
                  </form>
                ) : (
                  <div className="magic-link-sent">
                    <p>Si cet email est associé à un compte, un lien de connexion vous a été envoyé.</p>
                    <p>Vérifiez votre boîte mail.</p>
                  </div>
                )}
                <button
                  className="magic-link-toggle"
                  onClick={() => { setMagicMode(false); setMagicSent(false); setMagicEmail(""); }}
                >
                  ← Retour à la connexion classique
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
}

export default Login;
